import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { DateTypeDefaultValues } from "src/formBuilder/datamodel/structure";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { DateTimeView } from "./dateTime-view"
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class DateTimeViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.combo = new defaultValueSelector(this);
        this.combo.onSelectionChanged = x=>this.defaultValueType = getAsNumber(x.id);
    }
    GetDefaultView(): View <ViewModel> {
        return new DateTimeView();
    }
    public getTypeId(): string {
        return "VM-38FC17C1-0ECD-464B-8554-C53006C24716"
    }
    public set combo(v: defaultValueSelector) { this._combo = v; } public get combo(): defaultValueSelector { return this._combo;} private _combo: defaultValueSelector;
    public set defaultValueType(v: number) { this._defaultValueType = getAsNumber(v,true); } public get defaultValueType(): number { return this._defaultValueType;} private _defaultValueType: number;
    
    
    setDefaultValue(defaultValue: any): void {
        this.defaultValueType = defaultValue?.defaultValueType;
        this.combo.selectById(this.defaultValueType.toString());
    }
    getDefaultValue() {
        return {
            defaultValueType : this.defaultValueType
        }
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        if(this.defaultValueType==null){
            result.push('default value is not specified.')
        }
        return result;
    }
}

export class defaultValueSelector extends SelectorBaseViewModel<singleDefaultValue>{
    protected loadData(): Promise<singleDefaultValue[]> {
        const values = Object.keys(DateTypeDefaultValues).filter((item) => {
            return isNaN(Number(item));
        });
        return Promise.resolve(values.map(x=>{
            let r = new singleDefaultValue(this,DateTypeDefaultValues[x],x);
            return r;
        }))        
    }
    
}
export class singleDefaultValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,title:string) {
        super(parent);
        this.id = id;
        this.title = title;   
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}